import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SidebarComponent} from "./sidebar/sidebar.component";
import {IonicModule} from "@ionic/angular";
import { ToolbarComponent } from "../components/toolbar/toolbar.component";
import { SafePipe } from '../pages/quiz-list/safe.pipe';



@NgModule({
  declarations: [SidebarComponent, ToolbarComponent, SafePipe],
  imports: [
    CommonModule,
    IonicModule,
    IonicModule.forRoot(),
  ],
  exports: [
    SidebarComponent,
    ToolbarComponent,
    SafePipe
  ]
})
export class SharedComponentsModule { }
